import { render, staticRenderFns } from "./PaketMembershipPelatihanNon.vue?vue&type=template&id=1a8b4356"
import script from "./PaketMembershipPelatihanNon.vue?vue&type=script&lang=js"
export * from "./PaketMembershipPelatihanNon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports